import { AbstractService } from "./abstract.service";

export class SettingPrintsService extends AbstractService {
  static get entity() {
      return '/nsh/main/api/template'
  }

  static async searchItem(params) {
    try {
      const response = await this.callApi().post(
          `${this.entity}/search`,
          params
      )
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
    }
  }

  static async updateItem(params) {
    try {
      const response = await this.callApi().put(`${this.entity}`, params)
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
    }
  }

  static async getDefaultItem(params) {
    try {
      const response = await this.callApi().get(`${this.entity}/get-default-template/?${params}`);
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
    }
  }

  static async getKeyWordBill(params) {
    try {
      const response = await this.callApi().get(`${this.entity}/search-keyword/?${params}`);
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
    }
  }

  static async getTempBill(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/print-sale-order`,
        _params
      );
      return this.responseWrapper(response, response.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
